import loadable from '@loadable/component';
import giftGuidePageQuery from './query.graphql';

const GiftGuide = loadable(() =>
  import(/* webpackChunkName: "gift-guide" */ './gift-guide')
);

GiftGuide.graphQL = giftGuidePageQuery;

GiftGuide.variables = ({
  name,
  list,
  min_price, // eslint-disable-line camelcase
  max_price, // eslint-disable-line camelcase
  offset,
}) => ({
  name,
  list,
  min_price, // eslint-disable-line camelcase
  max_price, // eslint-disable-line camelcase
  offset: parseInt(offset, 10) || 0,
  limit: 45,
});

GiftGuide.group = ({ name, variables }) => {
  const groupVariables = variables
    ? Object.keys(variables).map(key => variables[key])
    : [];

  return `${name}_${groupVariables.join('_')}`;
};

GiftGuide.loadOrder = [{}];

export default GiftGuide;
